import React from 'react'
import SettingApiForm from '../components/setting/settingKdvForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex